<template>
     <div id="fileDialogModal" aria-hidden="true" aria-labelledby="fileDialogModalTitle" class="modal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="d-flex align-items-center">
                        <svg class="bi bi-exclamation-lg" fill="currentColor" height="98" viewBox="0 0 16 16"
                            width="60" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0L7.005 3.1ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"/>
                        </svg>
                        <div class="txt mx-auto">
                            <span class="title">You are a Dot member,  </span><br>
                            <span class="comment">You must join to use the service.</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" type="button" @click="joinService">Join service</button>
                    <button class="btn btn-secondary" type="button" @click="close">Cancel</button>
                </div>
            </div>
      </div>
    </div>
</template>
<script>
    import { $axios } from "@/dot-ui/index.js";
    export default 
    {
        data() {
            return {
                param: {
                    SITE_NO: "",
                    COMP_NO: "",
                    USER_NO: "",
                    USER_ID: "",
                    REALM: ""
                },
            }
        },
        methods: 
        {
            // 다이얼로그 열기
            open(siteNo, compNo)
            {
                this.param.SITE_NO = siteNo;
                this.param.COMP_NO = compNo;

                const modal = document.getElementById('fileDialogModal');
                modal.classList.add('show');
                modal.style.display = 'block';
            },
            // 서비스 가입하기
            async joinService()
            {
                let url = "/user-app/v2/users/me";
                let response = await $axios.get(url);
                if (response.status === 200) {
                    this.param.USER_ID = response.data.USER_ID;
                    this.param.USER_NO = response.data.USER_NO;
                    this.param.REALM = response.data.REALM;
                    url = "/user-app/v2/users/site";
                    response = await $axios.post(url, this.param);
                    if (response.status == 201 || response.status == 200) {
                        this.$parent.loginCallback();
                        this.close();
                    } else {
                        this.$parent.showMessage(response);
                        this.close();
                    }
                }
            },
            // 닫기
            close()
            {
                const modal = document.getElementById('fileDialogModal');
                modal.classList.remove('show');
                modal.style.display = 'none';
            },

        },
    }  
</script>
<style scoped>
    #fileName {
        display: block;
    }

    #fileDescript {
        max-height: 90px;
        border:1px solid gray;
    }

    .file-description {
        width: 50%;
        max-width: 50%;
        margin-right: auto;
    }

    #fileDialogModal {
        background-color: rgba(0, 0, 0, 0.7);
    }

    .modal-body .title {
        font-size: 12pt;
        font-weight: bold;
    }

    .modal-body .comment {
        font-size: 12pt;
        font-weight: bold;
    }

</style>